import { MemberSettingNameMode, MemberUniqueInfoCollection, UpdatePersonalInfoRequest } from "kz-ui-sdk";

export const buildPersonalInfoRequest = (
  v: {
    firstName: string;
    lastName: string;
    accountName: string;
    pan?: string;
    cpf?: string;
    curp?: string;
    pidType?: string;
    pidNumber?: string;
  },
  nameMode?: MemberSettingNameMode | null,
): UpdatePersonalInfoRequest => {
  const pidType = v.pidType;
  const pidNumber = v.pidNumber?.trim();
  const hasValidPidNumber = pidNumber && pidNumber.length > 0;

  const info: Record<string, string | undefined> = {
    [MemberUniqueInfoCollection.PAN]: v.pan?.trim() || undefined,
    [MemberUniqueInfoCollection.CPF]: v.cpf?.trim() || undefined,
    [MemberUniqueInfoCollection.CURP]: v.curp?.trim() || undefined,
  };

  // Map pidType to corresponding MemberUniqueInfoCollection enum value
  if (pidType && hasValidPidNumber) {
    switch (pidType) {
      case "dni":
        info[MemberUniqueInfoCollection.DNI] = pidNumber;
        break;
      case "ce":
        info[MemberUniqueInfoCollection.CE] = pidNumber;
        break;
      case "pen_pas":
        info[MemberUniqueInfoCollection.PEN_PAS] = pidNumber;
        break;
      case "ruc":
        info[MemberUniqueInfoCollection.RUC] = pidNumber;
        break;
      case "cc":
        info[MemberUniqueInfoCollection.CC] = pidNumber;
        break;
      case "nit":
        info[MemberUniqueInfoCollection.NIT] = pidNumber;
        break;
      case "cop_pas":
        info[MemberUniqueInfoCollection.COP_PAS] = pidNumber;
        break;
    }
  }
  switch (nameMode) {
    case MemberSettingNameMode.FirstLast:
      return {
        firstname: v.firstName?.trim() || undefined,
        lastname: v.lastName?.trim() || undefined,
        info,
      };
    case MemberSettingNameMode.FullInFirst:
      return {
        firstname: v.accountName?.trim() || undefined,
        info,
      };
    default:
      return {
        firstname: v.firstName?.trim() || undefined,
        lastname: v.lastName?.trim() || undefined,
        info,
      };
  }
};
